import { createAsyncThunk } from '@reduxjs/toolkit';
import getCredentials from '../../utils/getCredentials';
import getProjectFormVisibilityControl from 'scenes/ProjectForms/utils/getProjectFormVisibilityControl';

export const loadProjectFormVisibilityControl = createAsyncThunk(
  'projectForm/loadProjectFormVisibilityControl',
  async (projectId) => {
    const { accessKeyId, secretAccessKey, sessionToken } =
      await getCredentials();

    const params = {
      accessKeyId,
      secretAccessKey,
      sessionToken,
    };

    const projectFormVisibility = await getProjectFormVisibilityControl(
      projectId,
      params
    );

    return { projectFormVisibility };
  }
);
